export default __webpack_public_path__ + "static/media/nihal.e224503a.png";